<template>
    <div class="wrapper">

        <header-main></header-main>

        <div id="cancel-promo" class="popup popup--promocode">
            <div class="popup__wrapper">
                <div class="popup__content">
                    <div class="popup__wrap">
                        <button class="popup__btn popup__close" @click="closePopup">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.0002 36.6667C29.1668 36.6667 36.6668 29.1667 36.6668 20C36.6668 10.8334 29.1668 3.33337 20.0002 3.33337C10.8335 3.33337 3.3335 10.8334 3.3335 20C3.3335 29.1667 10.8335 36.6667 20.0002 36.6667Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                                <path d="M15.2832 24.7165L24.7165 15.2832" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M24.7165 24.7165L15.2832 15.2832" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </button>
                        <div class="popup__main">
                            <div class="popup__title title">
                                <svg width="168" height="43" viewBox="0 0 168 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M153.094 17.3027L138.864 3.14195L124.625 17.3027L110.395 3.14195L96.1652 17.3027L83.6144 4.81251L71.0549 17.3027L56.8249 3.14195L42.5862 17.3027L28.3562 3.14195L14.1262 17.3027L0 3.24582L1.57534 1.67048L14.1262 14.1607L28.3562 -7.717e-05L42.5862 14.1607L56.8249 -7.717e-05L71.0549 14.1607L83.6144 1.66182L96.1652 14.1607L110.395 -7.717e-05L124.625 14.1607L138.864 -7.717e-05L153.094 14.1607L165.653 1.67048L167.22 3.24582L153.094 17.3027Z"
                                        fill="#E9417D"
                                    ></path>
                                    <path
                                        d="M153.096 42.6211L138.866 28.4603L124.627 42.6211L110.397 28.4603L96.1668 42.6211L84.8798 31.3859L84.8711 28.2353L96.1668 39.4791L110.397 25.3183L124.627 39.4791L138.866 25.3183L153.096 39.4791L165.655 26.9888L167.222 28.5728L153.096 42.6211Z"
                                        fill="#E9417D"
                                    ></path>
                                </svg>
                                {{ $store.state.translation.cashier.promotions_history.cancel_promo }}
                                <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M54.7825 5.02247C53.6325 6.17247 51.7725 6.17247 50.6225 5.02247C49.4725 3.87247 49.4725 2.0125 50.6225 0.8625C51.7725 -0.2875 53.6325 -0.2875 54.7825 0.8625C55.9325 2.0125 55.9325 3.87247 54.7825 5.02247ZM67.2225 13.3025C66.0725 12.1525 64.2125 12.1525 63.0625 13.3025C61.9125 14.4525 61.9125 16.3125 63.0625 17.4625C64.2125 18.6125 66.0725 18.6125 67.2225 17.4625C68.3725 16.3125 68.3725 14.4525 67.2225 13.3025ZM79.6625 25.7425C78.5125 24.5925 76.6525 24.5925 75.5025 25.7425C74.3525 26.8925 74.3525 28.7525 75.5025 29.9025C76.6525 31.0525 78.5125 31.0525 79.6625 29.9025C80.8125 28.7525 80.8125 26.8925 79.6625 25.7425ZM92.1025 38.1825C90.9525 37.0325 89.0925 37.0325 87.9425 38.1825C86.7925 39.3325 86.7925 41.1925 87.9425 42.3425C89.0925 43.4925 90.9525 43.4925 92.1025 42.3425C93.2525 41.1925 93.2525 39.3325 92.1025 38.1825ZM104.542 50.6225C103.392 49.4725 101.533 49.4725 100.383 50.6225C99.2325 51.7725 99.2325 53.6325 100.383 54.7825C101.533 55.9325 103.392 55.9325 104.542 54.7825C105.692 53.6325 105.692 51.7725 104.542 50.6225ZM42.3425 13.3025C41.1925 12.1525 39.3325 12.1525 38.1825 13.3025C37.0325 14.4525 37.0325 16.3125 38.1825 17.4625C39.3325 18.6125 41.1925 18.6125 42.3425 17.4625C43.4925 16.3125 43.4925 14.4525 42.3425 13.3025ZM54.7825 25.7425C53.6325 24.5925 51.7725 24.5925 50.6225 25.7425C49.4725 26.8925 49.4725 28.7525 50.6225 29.9025C51.7725 31.0525 53.6325 31.0525 54.7825 29.9025C55.9325 28.7525 55.9325 26.8925 54.7825 25.7425ZM67.2225 38.1825C66.0725 37.0325 64.2125 37.0325 63.0625 38.1825C61.9125 39.3325 61.9125 41.1925 63.0625 42.3425C64.2125 43.4925 66.0725 43.4925 67.2225 42.3425C68.3725 41.1925 68.3725 39.3325 67.2225 38.1825ZM79.6625 50.6225C78.5125 49.4725 76.6525 49.4725 75.5025 50.6225C74.3525 51.7725 74.3525 53.6325 75.5025 54.7825C76.6525 55.9325 78.5125 55.9325 79.6625 54.7825C80.8125 53.6325 80.8125 51.7725 79.6625 50.6225ZM92.1025 63.0625C90.9525 61.9125 89.0925 61.9125 87.9425 63.0625C86.7925 64.2125 86.7925 66.0725 87.9425 67.2225C89.0925 68.3725 90.9525 68.3725 92.1025 67.2225C93.2525 66.0725 93.2525 64.2125 92.1025 63.0625ZM29.9025 25.7425C28.7525 24.5925 26.8925 24.5925 25.7425 25.7425C24.5925 26.8925 24.5925 28.7525 25.7425 29.9025C26.8925 31.0525 28.7525 31.0525 29.9025 29.9025C31.0525 28.7525 31.0525 26.8925 29.9025 25.7425ZM42.3425 38.1825C41.1925 37.0325 39.3325 37.0325 38.1825 38.1825C37.0325 39.3325 37.0325 41.1925 38.1825 42.3425C39.3325 43.4925 41.1925 43.4925 42.3425 42.3425C43.4925 41.1925 43.4925 39.3325 42.3425 38.1825ZM54.7825 50.6225C53.6325 49.4725 51.7725 49.4725 50.6225 50.6225C49.4725 51.7725 49.4725 53.6325 50.6225 54.7825C51.7725 55.9325 53.6325 55.9325 54.7825 54.7825C55.9325 53.6325 55.9325 51.7725 54.7825 50.6225ZM67.2225 63.0625C66.0725 61.9125 64.2125 61.9125 63.0625 63.0625C61.9125 64.2125 61.9125 66.0725 63.0625 67.2225C64.2125 68.3725 66.0725 68.3725 67.2225 67.2225C68.3725 66.0725 68.3725 64.2125 67.2225 63.0625ZM79.6625 75.5025C78.5125 74.3525 76.6525 74.3525 75.5025 75.5025C74.3525 76.6525 74.3525 78.5125 75.5025 79.6625C76.6525 80.8125 78.5125 80.8125 79.6625 79.6625C80.8125 78.5125 80.8125 76.6425 79.6625 75.5025ZM17.4625 38.1825C16.3125 37.0325 14.4525 37.0325 13.3025 38.1825C12.1525 39.3325 12.1525 41.1925 13.3025 42.3425C14.4525 43.4925 16.3125 43.4925 17.4625 42.3425C18.6125 41.1925 18.6125 39.3325 17.4625 38.1825ZM29.9025 50.6225C28.7525 49.4725 26.8925 49.4725 25.7425 50.6225C24.5925 51.7725 24.5925 53.6325 25.7425 54.7825C26.8925 55.9325 28.7525 55.9325 29.9025 54.7825C31.0525 53.6325 31.0525 51.7725 29.9025 50.6225ZM42.3425 63.0625C41.1925 61.9125 39.3325 61.9125 38.1825 63.0625C37.0325 64.2125 37.0325 66.0725 38.1825 67.2225C39.3325 68.3725 41.1925 68.3725 42.3425 67.2225C43.4925 66.0725 43.4925 64.2125 42.3425 63.0625ZM54.7825 75.5025C53.6325 74.3525 51.7725 74.3525 50.6225 75.5025C49.4725 76.6525 49.4725 78.5125 50.6225 79.6625C51.7725 80.8125 53.6325 80.8125 54.7825 79.6625C55.9325 78.5125 55.9325 76.6425 54.7825 75.5025ZM67.2225 87.9425C66.0725 86.7925 64.2125 86.7925 63.0625 87.9425C61.9125 89.0925 61.9125 90.9525 63.0625 92.1025C64.2125 93.2525 66.0725 93.2525 67.2225 92.1025C68.3725 90.9525 68.3725 89.0825 67.2225 87.9425ZM5.02253 50.6225C3.87253 49.4725 2.0125 49.4725 0.8625 50.6225C-0.2875 51.7725 -0.2875 53.6325 0.8625 54.7825C2.0125 55.9325 3.87253 55.9325 5.02253 54.7825C6.17253 53.6325 6.17253 51.7725 5.02253 50.6225ZM17.4625 63.0625C16.3125 61.9125 14.4525 61.9125 13.3025 63.0625C12.1525 64.2125 12.1525 66.0725 13.3025 67.2225C14.4525 68.3725 16.3125 68.3725 17.4625 67.2225C18.6125 66.0725 18.6125 64.2125 17.4625 63.0625ZM29.9025 75.5025C28.7525 74.3525 26.8925 74.3525 25.7425 75.5025C24.5925 76.6525 24.5925 78.5125 25.7425 79.6625C26.8925 80.8125 28.7525 80.8125 29.9025 79.6625C31.0525 78.5125 31.0525 76.6425 29.9025 75.5025ZM42.3425 87.9425C41.1925 86.7925 39.3325 86.7925 38.1825 87.9425C37.0325 89.0925 37.0325 90.9525 38.1825 92.1025C39.3325 93.2525 41.1925 93.2525 42.3425 92.1025C43.4925 90.9525 43.4925 89.0825 42.3425 87.9425ZM54.7825 100.372C53.6325 99.2225 51.7725 99.2225 50.6225 100.372C49.4725 101.522 49.4725 103.382 50.6225 104.532C51.7725 105.682 53.6325 105.682 54.7825 104.532C55.9325 103.392 55.9325 101.522 54.7825 100.372Z"
                                        fill="#E9417D"
                                    ></path>
                                </svg>
                            </div>
                            <div class="popup__question">
                                {{ $store.state.translation.cashier.promotions_history.you_shure }}
                            </div>
                            <form v-on:submit.prevent="cancelPromotion()" v-if="cancel.promotion">
                                <div class="popup__buttons">

                                    <button type="submit" :class="{'disabled-button': loader_button}">
                                        <loading-button v-if="loader_button"/>
                                        <span>{{ $store.state.translation.cashier.promotions_history.yes }}</span>
                                    </button>

                                    <button @click="closePopup" type="button"><span>{{ $store.state.translation.cashier.promotions_history.no }}</span></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <main class="page page--pt">
            <section class="content content--mb content--mb-very-big">
                <div class="content__container promo-history-row">

                    <cashier-personal-info></cashier-personal-info>
                    
                    <table class="content__table table-pc table-pc--six">
                        <thead>
                            <tr>
                                <th>{{ $store.state.translation.cashier.promotions_history.date_create }} <br/> {{ $store.state.translation.cashier.promotions_history.date_end }}</th>
                                <th>{{ $store.state.translation.cashier.promotions_history.type_promocode }}</th>
                                <th>{{ $store.state.translation.cashier.promotions_history.wager }}</th>
                                <th>{{ $store.state.translation.cashier.promotions_history.amount }}</th>
                                <th>{{ $store.state.translation.cashier.promotions_history.wagered }}</th>
                                <th>{{ $store.state.translation.cashier.promotions_history.status }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in promotions">
                                <td>
                                    {{ $moment(row.start_at).format('YYYY-MM-DD H:mm:ss') }} <br/>
                                    {{ $moment(row.expire_at).format('YYYY-MM-DD H:mm:ss') }}
                                </td>
                                <td>
                                    <router-link :to="{name: 'Game', params: {mode: 'real', slug: row.game_slug}}" v-if="row.type == 2">
                                        <img 
                                        :content="row.game_name"
                                        v-tippy="{arrow : true, arrowType: 'round', theme: 'rejected_doc'}"
                                        :src="row.game_image" 
                                        class="promo__game__img">
                                    </router-link>
                                    {{ utils.types.find(el => el.key == row.type).name }}
                                </td>
                                <td>{{ row.wager }}x</td>
                                <td>{{ parseFloat(row.amount).toFixed(2) }}</td>
                                <td>{{ parseFloat(row.wagered_amount) > parseFloat(row.to_wager_amount) ? parseFloat(row.to_wager_amount) : parseFloat(row.wagered_amount).toFixed(2) }} / {{ parseFloat(row.to_wager_amount).toFixed(2) }}</td>
                                <td>
                                    <span>{{ utils.statuses.find(el => el.key == row.status).name }}</span>
                                    <img
                                        v-if="[1,2].includes(row.status)"
                                        @click="openPopup('cancel-promo'), cancel.promotion = row"
                                        :class="{'disabled-button': loader}"
                                        :content="$store.state.translation.cashier.promotions_history.cancel_promotion"
                                        v-tippy="{arrow : true, arrowType: 'round', theme: 'rejected_doc'}"
                                        src="../../assets/img/cancel.svg" 
                                        class="promocode_cancel">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="history-preloader" v-if="search_loader">
                        <div class="preloader__row">
                            <div class="preloader__item"></div>
                            <div class="preloader__item"></div>
                        </div>
                    </div>

                    <div class="show-more__container content--mt">
                        <div class="show-more__row show-more__row--center">
                            <button type="button" class="show-more__more" v-if="!nomore" @click="getPromotions" :class="{'_disabled': preloader}">
                                <span>{{ $store.state.translation.default.show_more }}</span>
                            </button>
                        </div>
                    </div>

                </div>
            </section>
        </main>

        <footer-main></footer-main>
    </div>
</template>


<script>
    export default {
        metaInfo () {
            return {
                title: this.$store.state.translation.cashier.promotions_history.meta.title,
                meta: [
                    {
                        name: 'title', 
                        content: this.$store.state.translation.cashier.promotions_history.meta.title
                    },
                    {
                        name: 'keywords', 
                        content: this.$store.state.translation.cashier.promotions_history.meta.keywords
                    },
                    {
                        name: 'description', 
                        content: this.$store.state.translation.cashier.promotions_history.meta.description
                    }
                ]
            }
        },
        data() {
            return {
                nomore: true,
                search_loader: false,
                loader_button: false,
                loader: false,

                cancel: {
                    balance: 0,
                    promotion: null
                },
                promotions: [],
                data: {
                    limit: 10,
                    offset: 0
                },
                utils: {
                    types: [
                        {
                            name: this.$store.state.translation.cashier.promotions_history.voucher,
                            key: 1
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.freespins,
                            key: 2
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.cash_bonus,
                            key: 3
                        }
                    ],
                    statuses: [
                        {
                            name: this.$store.state.translation.cashier.promotions_history.waiting,
                            key: 0
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.activated,
                            key: 1
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.confirmed,
                            key: 2
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.canceled,
                            key: 3
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.wagered,
                            key: 4
                        },
                        {
                            name: this.$store.state.translation.cashier.promotions_history.expired,
                            key: 5
                        }
                    ]
                }
            }
        },
        methods: {
            getPromotions () {
                this.search_loader = true

                this.$axios.post('/promotions/history', JSON.stringify({
                    status: null,
                    limit: this.data.limit,
                    offset: this.data.offset
                }))
                .then((response) => {
                    this.search_loader = false
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':

                            this.promotions = this.promotions.concat(response.promotions)
                            this.data.offset ++
                            if(response.promotions.length < this.data.limit) {
                                this.nomore = true
                            } else {
                                this.nomore = false
                            }

                            this.setUser(response.user)
                            
                            break
                        default:
                            this.$toast.error(this.$store.state.translation.default.unknown_error)
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if(response && 'status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })
            },
            cancelPromotion() {
                this.loader = true
                this.loader_button = true
                this.$axios.post('/promotions/cancel', JSON.stringify({
                    id: this.cancel.promotion.id
                }))
                .then((response) => {
                    this.loader = false
                    this.loader_button = false
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':

                            let index = this.promotions.findIndex(el => el.id == this.cancel.promotion.id)
                            this.promotions[index].status = 3

                            this.$toast.success(response.message)

                            this.closePopup(document.getElementById('cancel-promo'))

                            this.setUser(response.user)
                            
                            break
                        default:
                            this.$toast.error(this.$store.state.translation.default.unknown_error)
                    }
                }).catch((error) => {
                    this.loader = false
                    this.loader_button = false
                    let response = error.response.data
                    this.setUser(response.user)

                    if(response && 'status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })
            }
        },
        beforeMount() {
            this.getPromotions()
        }
    }
</script>
